import { useState } from "react";
import Filters from "../../Products/Filters";
import { VIEW_STATUS_REPORTS } from "../../Products/EditItem/Constants";
import { useAppDispatch, useAppSelector } from "../../../store";
import { initialStatusReportsRequest, updateStatusReportsViewSelectedFilterValues } from "../../../reducers/statusReportsReducer";
import { Box, Button, Card, CardContent } from "@mui/material";
import FileDownload from "../../../components/FileDownload";
import Loader from "../../../components/Loader";

export const StatusReports = () => {
    const [filtersExpanded, setFiltersExpanded] = useState<boolean>(true);
    const [disableDownloadButtons, setDisableDownloadButtons] = useState<boolean>(false);
    const dispatch = useAppDispatch();
    const selectedFilterValues = useAppSelector((state) => state.statusReports.statusReportsListView.selectedFilterValues);

    const handleExpandClick = () => {
        setFiltersExpanded(!filtersExpanded);
    };

    const handleApplyFilterClick = (filterValues) => {
        if (filterValues.projectCode) {
            dispatch(updateStatusReportsViewSelectedFilterValues({
                ...selectedFilterValues,
                projectCode: filterValues.projectCode
            }));
        } else if (Object.values(filterValues)?.length) {
            dispatch(updateStatusReportsViewSelectedFilterValues({
                ...filterValues
            }));
        } else {
            //reset the filters
            dispatch(updateStatusReportsViewSelectedFilterValues(initialStatusReportsRequest));
        }
    };

    const handleCSVForStatusReportsList = async (fileName: string, fileFormat: string) => {
        const fileDownload = await FileDownload({ 
          requestInput: {
            ...selectedFilterValues,
            reportType: fileName === "Design_Report" ? "Design" : "Sampling"
          }, 
          inputFileName: fileName, 
          inputFileFormat: fileFormat, 
          setLoading: setDisableDownloadButtons
        });
        await fileDownload.handleDownload();
    };

    return (<div className="status-reports">
        <Loader isLoading={disableDownloadButtons} />
        <Filters
            onApplyFilter={handleApplyFilterClick}
            filtersExpanded={filtersExpanded}
            handleExpandClick={handleExpandClick}
            viewMode={VIEW_STATUS_REPORTS}
        />
        <Card>
            <CardContent>
                <Box className="download-buttons">
                    <Button variant="contained" disabled={disableDownloadButtons} onClick={() => handleCSVForStatusReportsList("Design_Report", "Design Report")}>Download Design Report</Button>
                    <Button variant="contained" disabled={disableDownloadButtons} onClick={() => handleCSVForStatusReportsList("Sampling_Report", "Sampling Report")}>Download Sampling Report</Button>
                </Box>
            </CardContent>
        </Card>
    </div>);
};